export enum DeliverableReportMapping {
  Statement = 2,
  Valuation = 3,
  JournalEntries = 4,
  Regression = 5,
  Memo = 6,
  JournalEntryAtMaturity = 7,
  Amortisation = 8,
}
